import React from "react";
import { useTranslation } from "react-i18next";
import { FaGlobe } from "react-icons/fa";
import { isRtlLanguage } from "../../utils/i18n";

function LanguageSwitcher({ onLanguageChange, compact = false }) {
  const { i18n } = useTranslation();
  const isRtl = isRtlLanguage(i18n.language);

  const switchLanguage = (language) => {
    if (i18n.language === language) return;
    onLanguageChange?.();
    i18n.changeLanguage(language);
  };

  return (
    <div
      className={`caf-lang-switch${compact ? " caf-lang-switch--compact" : ""}`}
      role="group"
      aria-label="Language"
    >
      <FaGlobe className="caf-lang-switch__icon" aria-hidden="true" />
      <button
        type="button"
        className={`caf-lang-switch__btn enFont${!isRtl ? " is-active" : ""}`}
        onClick={() => switchLanguage("en")}
        aria-pressed={!isRtl}
      >
        EN
      </button>
      <span className="caf-lang-switch__divider" aria-hidden="true" />
      <button
        type="button"
        className={`caf-lang-switch__btn arFont${isRtl ? " is-active" : ""}`}
        onClick={() => switchLanguage("ar")}
        aria-pressed={isRtl}
      >
        AR
      </button>
    </div>
  );
}

export default LanguageSwitcher;
